import util from '@/libs/util'

// sendLeeBotStream: POST SSE流式输出接口（原生 fetch 版，自动带 token 和 API 基础路径）
export function sendLeeBotStream ({ userInput, userId, onMessage, onError, onComplete }) {
  const API_BASE = process.env.VUE_APP_API || ''
  const token = util.cookies.get('token')
  window.fetch(`${API_BASE}/api/order/lee-bot/stream`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token ? `Bearer ${token}` : ''
      // 如果后端不是 Authorization，可以改成 'token': token
    },
    body: JSON.stringify({
      userInput: userInput,
      userId: userId || ''
    })
  }).then(response => {
    if (!response.body || !window.ReadableStream) {
      onError && onError('浏览器不支持流式输出')
      onComplete && onComplete()
      return
    }
    const reader = response.body.getReader()
    const decoder = new TextDecoder('utf-8')
    let buffer = ''
    const readChunk = () => {
      reader.read().then(({ done, value }) => {
        if (done) {
          onComplete && onComplete()
          return
        }
        buffer += decoder.decode(value, { stream: true })
        let lines = buffer.split('\n')
        buffer = lines.pop()
        for (let line of lines) {
          console.log('SSE line:', line)
          if (line.trim().startsWith('data:')) {
            try {
              const jsonStr = line.replace('data:', '').trim()
              console.log('SSE jsonStr:', jsonStr)
              if (jsonStr) {
                const msg = JSON.parse(jsonStr)
                onMessage && onMessage(msg)
              }
            } catch (e) {
              console.error('SSE JSON parse error:', e)
            }
          }
        }
        readChunk()
      }).catch(err => {
        onError && onError(err)
        onComplete && onComplete()
      })
    }
    readChunk()
  }).catch(err => {
    onError && onError(err)
    onComplete && onComplete()
  })
}
